import type { IconData } from '@stacksjs/iconify-core'

export const luggage: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M15 6v8h-2V6H7v8H5V6a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3M7.17 4h5.66a3.004 3.004 0 0 0-5.66 0M5.1 4a5.002 5.002 0 0 1 9.8 0h.1a5 5 0 0 1 5 5v2a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default luggage
